// extracted by mini-css-extract-plugin
export default {"postStats":"PostCard_postStats__SCevz","liked":"PostCard_liked__0QMv6","likeContainer":"PostCard_likeContainer__iuuc4"};